import api from "!../../../../../../../project/ulms/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../project/ulms/node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../../../../../../project/ulms/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../project/ulms/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../../../../../../project/ulms/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!../../../../../../../project/ulms/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=33c50641&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};